import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataTt from './phonics/phonics_data_tt';

function PhonicsTt() {
  return <PhonicsAtoZ letterData={letterDataTt} />;
}

export default PhonicsTt;
